import { render, staticRenderFns } from "./WsLinealExpertCardList.vue?vue&type=template&id=47ced724&scoped=true"
import script from "./WsLinealExpertCardList.vue?vue&type=script&lang=js"
export * from "./WsLinealExpertCardList.vue?vue&type=script&lang=js"
import style0 from "./WsLinealExpertCardList.vue?vue&type=style&index=0&id=47ced724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ced724",
  null
  
)

export default component.exports